import http from './http'
const base = '/Telas/ProgramacaoPagamento'
export default {
  async getPaged (params) { return (await http.get(`${base}/GetPaged`, { params })).data },
  async getById (id) { return (await http.get(`${base}/GetById/${id}`)).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async add (input) { return (await http.post(`${base}/Add`, input)).data },
  async cancel (id, reason) { await http.post(`${base}/Cancel/${id}`, { reason }) }
}
